import React from 'react';
import { string } from 'prop-types';
import { staticTextType, staticTextTypeValues } from '../../constants/types';
import { getTranslation } from '../../i18n';
import TranslatedHTMLText from '../TranslatedHTMLText';
import style from './StaticText.module.css';

const StaticText = ({ staticText, lang }) => {
  switch (staticText.type) {
    case staticTextTypeValues.HEADING:
      return <h3 className={style.heading}>{getTranslation(staticText.text, lang)}</h3>;
    default:
      /* WARNING: UH-670 - This is not accessible in case the html is not formated correctly */
      return (
        <TranslatedHTMLText
          className={style.instructionText}
          html={staticText.text}
          inLanguage={lang}
        />
      );
  }
};

StaticText.propTypes = {
  lang: string.isRequired,
  staticText: staticTextType.isRequired
};

export default StaticText;
